module.exports = __webpack_public_path__ + "img/159.d8694b07.jpg";